import { CalendarDays, GraduationCap, Wallet, FileCheck2, AlertCircle } from "lucide-react";
import { DOK_KATEGORIEN, dokumenteNachCode, pflichtCodes } from "@/lib/dokumentKategorien";

const fmt = (d) => (d ? new Date(d).toLocaleDateString("de-DE") : "–");
const FIN = { bildungsgutschein: "Bildungsgutschein", einrichtung: "Einrichtung", selbstzahler: "Selbstzahler" };

const Feld = ({ icon: Icon, label, wert, testid }) => (
  <div className="flex items-center gap-2 min-w-0" data-testid={testid}>
    <Icon size={15} className="text-[#D9775A] shrink-0" />
    <div className="min-w-0">
      <p className="text-[10px] uppercase tracking-wider text-stone-500 leading-none">{label}</p>
      <p className="text-sm font-medium text-stone-900 truncate">{wert}</p>
    </div>
  </div>
);

export const TeilnehmerStatusLeiste = ({ teilnehmer, anhaenge, regel, onDokumente }) => {
  const nachCode = dokumenteNachCode(anhaenge);
  const pflicht = pflichtCodes(regel);
  const fehlend = pflicht.filter((c) => !nachCode[c]?.length);
  const quote = pflicht.length ? Math.round(((pflicht.length - fehlend.length) / pflicht.length) * 100) : 100;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4 pt-4 border-t border-stone-100" data-testid="tn-status-leiste">
      <Feld icon={GraduationCap} label="Kurs" wert={teilnehmer.kurs || "–"} testid="tn-kurs" />
      <Feld icon={CalendarDays} label="Zeitraum" wert={teilnehmer.kurs_ende ? `${fmt(teilnehmer.kurs_start)} – ${fmt(teilnehmer.kurs_ende)}` : teilnehmer.kurs_start ? `ab ${fmt(teilnehmer.kurs_start)}` : "–"} testid="tn-zeitraum" />
      <Feld icon={Wallet} label="Finanzierung" testid="tn-finanzierung"
        wert={regel?.bg ? (regel.bg_nachweis ? "Bildungsgutschein – bestätigt" : "BG ohne Nachweis (nur Eintrag)") : (FIN[teilnehmer.finanzierungsart] || teilnehmer.bg_sz || "–")} />
      <button onClick={onDokumente} className="text-left group" data-testid="tn-dokumente-status">
        <div className="flex items-center gap-2">
          {fehlend.length ? <AlertCircle size={15} className="text-red-600" /> : <FileCheck2 size={15} className="text-emerald-600" />}
          <p className="text-[10px] uppercase tracking-wider text-stone-500 leading-none">{pflicht.length ? "AZAV-Pflichtunterlagen" : "Dokumente"}</p>
        </div>
        <div className="mt-1 h-1.5 rounded-full bg-stone-200 overflow-hidden">
          <div className={`h-full ${fehlend.length ? "bg-[#D9775A]" : "bg-emerald-600"}`} style={{ width: `${quote}%` }} />
        </div>
        <p className="text-xs mt-1 text-stone-700 group-hover:text-stone-950 truncate">
          {!pflicht.length ? `${(anhaenge || []).length} Dokumente · keine AZAV-Pflicht` : fehlend.length ? `Fehlt: ${fehlend.map((c) => DOK_KATEGORIEN[c].label).join(", ")}` : "Vollständig"}
        </p>
      </button>
    </div>
  );
};
